import type { BadgeProps } from '@wartek-id/badge'

import type {
  IFollowUpReflectionDocumentForm,
  TObservationResultTypes,
} from 'types/kinerja-pelaksanaan'

export const RATING_OBSERVASI_PRAKTIK_KINERJA_PEGAWAI_OPTIONS: Record<
  TObservationResultTypes,
  string
> = {
  NOT_STARTED: 'Belum Dilakukan',
  START_NOT_EFFECTIVE: 'Dilakukan tetapi Belum Efektif',
  START_EFFECTIVE: 'Dilakukan dan Efektif',
}

export const HASIL_OBSERVASI_PRAKTIK_KINERJA_PEGAWAI_BADGE: Record<
  TObservationResultTypes,
  { text: string; variant: BadgeProps['variant'] }
> = {
  NOT_STARTED: {
    text: 'Belum Dilakukan',
    variant: 'critical',
  },
  START_NOT_EFFECTIVE: {
    text: 'Dilakukan tapi Belum Efektif',
    variant: 'warning',
  },
  START_EFFECTIVE: {
    text: 'Dilakukan dan Efektif',
    variant: 'success',
  },
}

export const REFLEKSI_EVALUASI_TINDAK_LANJUT_CONTENT: Record<
  keyof IFollowUpReflectionDocumentForm,
  { question: string; label: string }
> = {
  inspiration: {
    question: 'Apa inspirasi baru yang Anda dapatkan dari upaya tindak lanjut?',
    label: 'Inspirasi',
  },
  achievement: {
    question:
      'Apa kemajuan yang berhasil Anda capai dari upaya tindak lanjut yang Anda lakukan?',
    label: 'Capaian',
  },
  challenge: {
    question:
      'Apa hambatan yang Anda temui selama melakukan upaya tindak lanjut?',
    label: 'Tantangan',
  },
  improvementPlan: {
    question:
      'Apa upaya peningkatan untuk mengatasi tantangan dalam upaya tindak lanjut?',
    label: 'Upaya Perbaikan',
  },
  additionalInspiration: {
    question: 'Apa inspirasi baru yang Anda dapatkan dari upaya tindak lanjut?',
    label: 'Inspirasi',
  },
  additionalAchievement: {
    question:
      'Apa kemajuan yang berhasil Anda capai dari upaya tindak lanjut yang Anda lakukan?',
    label: 'Capaian',
  },
  additionalChallenge: {
    question:
      'Apa hambatan yang Anda temui selama melakukan upaya tindak lanjut?',
    label: 'Tantangan',
  },
  additionalImprovementPlan: {
    question:
      'Apa upaya peningkatan untuk mengatasi tantangan dalam upaya tindak lanjut?',
    label: 'Upaya Perbaikan',
  },
}
